import { useActionButtonContext } from '@aibees/elephant/context/action-button-context';
import { useTableActionContext } from '@aibees/elephant/context/table-action/context';
import { SearchModality } from '../feature/search-table-company/hooks/types';

/**
 * Whether Email Re-Verify applies to the current action flow.
 *
 * Both the enrichment option list and the save/export dialog default values read
 * this, so the row the user sees and the action in the request payload cannot
 * disagree — a hidden or disabled RHFCheckbox still submits its default value,
 * so gating only the UI would charge for an action the user never saw.
 *
 * Two gates:
 * - Net New (UNSAVED) records are freshly verified by Email Enrichment, so there
 *   is nothing to re-verify.
 * - A single record with no revealed email has nothing to re-verify either. Bulk
 *   flows have no one record to inspect, so the tab decides on its own.
 *
 * Not exported from the hooks barrel on purpose: it reads TableActionContext,
 * whose types import the barrel. Same reason as
 * use-get-credits-amount-type-on-action-popup.
 */
export function useCanReverifyEmail(): boolean {
  const { item } = useActionButtonContext();
  const { effectiveModality } = useTableActionContext();

  if (effectiveModality === SearchModality.UNSAVED) return false;

  return !item || !!item.revelation?.email;
}
